import * as BodyMapSelectors from './BodyMapReports'
import * as carePlanDocumentSelectors from './CarePlanDocs'
import * as CarePlanSelectors from './CarePlans'
import * as consentSelectors from './Consent'
import * as DataSelectors from './Data'
import * as DocumentSelectors from './Documents'
import * as emarSelectors from './eMAR'
import * as HandoverSelectors from './Handovers'
import * as InitialAssessmentSelectors from './InitialAssessments'
import * as ListSelectors from './Lists'
import * as LogSelectors from './Logs'
import * as needsAndSkillsSelectors from './NeedsAndSkills'
import * as OrganisationSelectors from './Organisation'
import * as ResidentSelectors from './Residents'
import * as RiskAssessmentSelectors from './RiskAssessments'
import * as subscriptionSelectors from './Subscriptions'
import * as TodoSelectors from './Todos'
import * as ZoneSelectors from './Zones'

const Selectors = {
  ...BodyMapSelectors,
  ...carePlanDocumentSelectors,
  ...CarePlanSelectors,
  ...consentSelectors,
  ...DataSelectors,
  ...DocumentSelectors,
  ...emarSelectors,
  ...HandoverSelectors,
  ...InitialAssessmentSelectors,
  ...ListSelectors,
  ...LogSelectors,
  ...OrganisationSelectors,
  ...ResidentSelectors,
  ...RiskAssessmentSelectors,
  ...subscriptionSelectors,
  ...TodoSelectors,
  ...ZoneSelectors,
  ...needsAndSkillsSelectors
}

export default Selectors
